// src/pages/admin/TransactionsImport.js
import React from "react";
import AdminTransactionsImportComp from "../../components/Admin/AdminTransactionsImport";

export default function AdminTransactionsImportPage() {
  return <AdminTransactionsImportComp />;
}
